<div>
  <div
    class="popup popup-basic"
    class="order__details"
    *ngIf="control.sysConfigsPrimed === false || (control.hasOrderDetails === false && control.hasErrorMessage === false)"
  >
    <div class="popup-body order__details__body" fxLayout="row wrap">
      <div fxFlexFill class="order__details_loading">Loading...</div>
    </div>
  </div>

  <div
    class="popup popup-basic"
    class="order__details"
    *ngIf="control.hasOrderDetails === false && control.hasErrorMessage === true"
  >
    <div class="popup-body order__details__body" fxLayout="row wrap">
      <div fxFlexFill>{{errorMessage}}</div>
    </div>
  </div>

  <div
    #popupBody
    class="popup popup-basic order__details"
    [ngStyle]="{'display': control.hasOrderDetails && control.sysConfigsPrimed ? 'block' : 'none' } "
  >
    <div>
      <!-- [ngClass]="{'popup-body': true, 'order__details__body': true, 'bmarkAlgo': orderDetails.isBenchmarkAlgoOrder}"  -->
      <!-- Explicitly seting the initial size of the Details panel to 686 - should we make the window resizable this should still be applicable I hope -->
      <div class="popup-body order__details__body" fxLayout="column">
        <div
          class="order__details__top__summary__wrapper"
          [class.buy]="intentType == OI.BUY"
          [class.sell]="intentType == OI.SELL"
          [ngStyle]="{'display': control.hasOrderDetails && control.sysConfigsPrimed && summary ? 'block' : 'none'}"
        >
          {{summary}}
        </div>
        <div class="divider"></div>
        <div class="order__details__top__section__wrapper">
          <div styleClass="order__details__body__fieldset" fxFlex="1 1 50.00%">
            <p-overlayPanel #infoClient styleClass="order__details__overlay" appendTo="body">
              <div fxLayout="row ">
                <div class="order__details__body__label_client">Client Name</div>
                <div class="order__details__body__value">{{orderDetails.clientName}}</div>
              </div>
              <div fxLayout="row ">
                <div class="order__details__body__label_client">Client Branch</div>
                <div class="order__details__body__value">{{orderDetails.clientBranch}}</div>
              </div>
              <div fxLayout="row ">
                <div class="order__details__body__label_client">Client Sales Group</div>
                <div class="order__details__body__value">{{orderDetails.clientSalesGroup}}</div>
              </div>
            </p-overlayPanel>

            <p-overlayPanel #infoAccount styleClass="order__details__overlay" appendTo="body">
              <div fxLayout="row ">
                <div class="order__details__body__label">Account Name</div>
                <div class="order__details__body__value">{{orderDetails.accountName}}</div>
              </div>
              <div fxLayout="row ">
                <div class="order__details__body__label">Account Booking Code</div>
                <div class="order__details__body__value">{{orderDetails.accountBookingCd}}</div>
              </div>
              <div fxLayout="row ">
                <div class="order__details__body__label">Contact</div>
                <div class="order__details__body__value">{{orderDetails.accountContact}}</div>
              </div>
            </p-overlayPanel>

            <p-overlayPanel #infoEntryUser styleClass="order__details__overlay" appendTo="body">
              <div fxLayout="row ">
                <div class="order__details__body__label_user">User ID</div>
                <div class="order__details__body__value">{{orderDetails.entryUser}}</div>
              </div>
              <div fxLayout="row ">
                <div class="order__details__body__label_user">User Branch</div>
                <div class="order__details__body__value">{{orderDetails.entryUserBranch}}</div>
              </div>
              <div fxLayout="row ">
                <div class="order__details__body__label_user">User Type</div>
                <div class="order__details__body__value">{{orderDetails.entryUserType}}</div>
              </div>
            </p-overlayPanel>

            <p-overlayPanel
              #infoContacts
              styleClass="order__details__overlay"
              appendTo="body"
              [nativeDesktopTooltip]="infoContactsToggle"
              [showCloseIcon]="false"
              [dismissable]="false"
              [style]="{'width': '940px'}"
            >
              <div fxLayout="row wrap">
                <div class="order__details__body__label" style="width: unset; text-align: left">
                  Client
                </div>
                <div class="order__details__body__value">{{orderDetails.clientName}}</div>
                <button
                  type="button"
                  (click)="infoContacts.hide()"
                  class="bfx-button-secondary-subtle bfx-icon-sm icon-close order__details__contacts__close"
                  placeholder="Close"
                  title="Close"
                ></button>
              </div>
              <div class="divider"></div>
              <p-dataTable
                [value]="orderDetails.contactData"
                scrollable="true"
                scrollHeight="200px"
              >
                <p-column field="contactNameTxt" header="Name" [style]="{'width':'100px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.contactNameTxt}}"
                    >
                      {{data.contactNameTxt}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="deskTxt" header="Desk" [style]="{'width':'100px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.deskTxt}}"
                    >
                      {{data.deskTxt}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="mobileTxt" header="Mobile" [style]="{'width':'100px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.mobileTxt}}"
                    >
                      {{data.mobileTxt}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="smsTxt" header="Sms" [style]="{'width':'100px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.smsTxt}}"
                    >
                      {{data.smsTxt}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="emailTxt" header="Email" [style]="{'width':'200px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.emailTxt}}"
                    >
                      {{data.emailTxt}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="notifyEntry" header="Entry" [style]="{'width':'60px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.notifyEntry}}"
                    >
                      {{data.notifyEntry}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="notifyModify" header="Modify" [style]="{'width':'60px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.notifyModify}}"
                    >
                      {{data.notifyModify}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="notifyExpiry" header="Expiry" [style]="{'width':'60px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.notifyExpiry}}"
                    >
                      {{data.notifyExpiry}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="notifyFill" header="Fill" [style]="{'width':'60px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.notifyFill}}"
                    >
                      {{data.notifyFill}}
                    </div>
                  </ng-template>
                </p-column>
                <p-column field="notifyCancel" header="Cancel" [style]="{'width':'60px'}">
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <div
                      class="ui-overlaypanel-cell"
                      [appendTo]="desktop ? 'target' : 'body'"
                      title="{{data.notifyCancel}}"
                    >
                      {{data.notifyCancel}}
                    </div>
                  </ng-template>
                </p-column>
              </p-dataTable>
            </p-overlayPanel>

            <div fxLayout="row wrap" class="order__details__client_id">
              <div fxFlex="0 0 116px" class="order__details__body__label">Client ID</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{orderDetails.clientId}}
              </div>
              <div
                class="order__details__body__infobox"
                [hidden]="!orderDetails.clientId"
                (mouseenter)="infoClient.toggle($event)"
                (mouseleave)="infoClient.toggle($event)"
              >
                i
              </div>
            </div>
            <div fxLayout="row wrap" class="order__details__account_id">
              <div fxFlex="0 0 116px" class="order__details__body__label">Account ID</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{isMultiAccountBenchmark? "Multiple": orderDetails.accountId}}
              </div>
              <div
                class="order__details__body__infobox"
                [hidden]="isMultiAccountBenchmark || !orderDetails.accountId"
                (mouseenter)="infoAccount.toggle($event)"
                (mouseleave)="infoAccount.toggle($event)"
              >
                i
              </div>
            </div>
            <div fxLayout="row wrap" class="order__details__contacts">
              <div fxFlex="0 0 116px" class="order__details__body__label">Contacts</div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                class="order__details__body__value order__details__body__value_contacts"
                [appendTo]="desktop ? 'target' : 'body'"
                bfxTooltip="{{orderDetails.contacts}}"
                tooltipPosition="top"
              >
                {{orderDetails.contacts}}
              </div>
              <div
                #infoContactsToggle
                class="order__details__body__infobox order__details__body__infobox order__details__body__infobox--clients fa icon-account_circle"
                [fxHide]="orderDetails.contacts == null"
                (click)="infoContacts.toggle($event)"
              ></div>
            </div>
            <div
              fxLayout="row wrap"
              *ngIf="clientTraderUsersEnabled"
              class="order__details__client_trader"
            >
              <div fxFlex="0 0 116px" class="order__details__body__label">Client Trader</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{orderDetails.clientTrader}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div *ngIf="!isGamma" fxLayout="row wrap" class="order__details__state">
              <div fxFlex="0 0 116px" class="order__details__body__label">State</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{orderDetails.state}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div fxLayout="row wrap" class="order__details__trader_group">
              <div fxFlex="0 0 116px" class="order__details__body__label">Trader Group</div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                class="order__details__body__value"
                [appendTo]="desktop ? 'target' : 'body'"
                bfxTooltip="{{orderDetails.traderGroup}}"
                tooltipPosition="top"
              >
                {{orderDetails.traderGroup}}
              </div>
              <div
                class="order__details__body__infobox--xfer"
                [hidden]="!orderDetails.targetGroup"
                [appendTo]="desktop ? 'target' : 'body'"
                bfxTooltip="{{orderDetails.targetGroup}}"
                tooltipPosition="right"
              >
                ⟶
              </div>
            </div>
            <div *ngIf="oboEnabled" fxLayout="row wrap" class="order__details__obo_client">
              <div fxFlex="0 0 116px" class="order__details__body__label">OBO Client</div>
              <div
                fxFlex="1 1 calc(100% - 117px)"
                class="order__details__body__value"
                title="{{orderDetails.oboClient}}"
              >
                {{orderDetails.oboClient}}
              </div>
            </div>
            <div *ngIf="oboEnabled" fxLayout="row wrap" class="order__details__obo_user">
              <div fxFlex="0 0 116px" class="order__details__body__label">OBO Entry User</div>
              <div
                fxFlex="1 1 calc(100% - 117px)"
                class="order__details__body__value"
                title="{{orderDetails.oboClient}}"
              >
                {{orderDetails.oboEntryUser}}
              </div>
            </div>
          </div>
          <div class="divider-vertical"></div>
          <div styleClass="order__details__body__fieldset" fxFlex="1 1 50.00%">
            <div *ngIf="!isGamma" fxLayout="row wrap" class="order__details__order_id">
              <div fxFlex="0 0 116px" class="order__details__body__label">Order ID</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{BfxConfigIDRefHelper.getOrderRef(orderDetails)}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div
              fxLayout="row wrap"
              class="order__details__strategy_id"
              *ngIf="orderDetails.strategyId"
            >
              <div fxFlex="0 0 116px" class="order__details__body__label">Strategy ID</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{BfxConfigIDRefHelper.getStrategyRef(orderDetails)}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>

            <div fxLayout="row wrap" class="order__details__clorder_id">
              <div fxFlex="0 0 116px" class="order__details__body__label">ClOrderID</div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                class="order__details__body__value"
                [appendTo]="desktop ? 'target' : 'body'"
                bfxTooltip="{{orderDetails.clOrderId}}"
                tooltipPosition="top"
              >
                {{orderDetails.clOrderId}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div fxLayout="row wrap" *ngIf="isBenchmarkOrder">
              <div fxFlex="0 0 116px" class="order__details__body__label">Spot Portfolio</div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                class="order__details__body__value"
                [appendTo]="desktop ? 'target' : 'body'"
                bfxTooltip="{{orderDetails.nettingId ?? '-'}}"
                tooltipPosition="top"
              >
                {{orderDetails.nettingId ?? '-'}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div fxLayout="row wrap" *ngIf="isBenchmarkOrder">
              <div fxFlex="0 0 116px" class="order__details__body__label">Forward Portfolio</div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                class="order__details__body__value"
                [appendTo]="desktop ? 'target' : 'body'"
                bfxTooltip="{{orderDetails.fwdNettingId ?? '-'}}"
                tooltipPosition="top"
              >
                {{orderDetails.fwdNettingId ?? '-'}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>

            <div fxLayout="row wrap" class="order__details__entry_channel">
              <div fxFlex="0 0 116px" class="order__details__body__label">Entry Channel</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{orderDetails.entryChannel}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div fxLayout="row wrap" class="order__details__entry_date">
              <div fxFlex="0 0 116px" class="order__details__body__label">Entry Date</div>
              <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                {{orderDetails.entryDate}}
              </div>
              <div class="order__details__body__infobox--placeholder"></div>
            </div>
            <div fxLayout="row wrap" class="order__details__entry_user">
              <div fxFlex="0 0 116px" class="order__details__body__label">Entry User</div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                *ngIf="displayUserNames"
                class="order__details__body__value"
              >
                {{orderDetails.entryUser}}
              </div>
              <div
                fxFlex="1 1 calc(100% - 132px)"
                *ngIf="!displayUserNames"
                class="order__details__body__value"
              >
                {{orderDetails.entryUserCode}}
              </div>
              <div
                class="order__details__body__infobox"
                [hidden]="!orderDetails.entryUser"
                (mouseenter)="infoEntryUser.toggle($event)"
                (mouseleave)="infoEntryUser.toggle($event)"
              >
                i
              </div>
            </div>
            <div *ngIf="oboEnabled" fxLayout="row wrap" class="order__details__obo_account">
              <div fxFlex="0 0 116px" class="order__details__body__label">OBO Account</div>
              <div
                fxFlex="1 1 calc(100% - 117px)"
                class="order__details__body__value"
                title="{{orderDetails.oboAccount}}"
              >
                {{orderDetails.oboAccount}}
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <p-tabView
          #tabView
          fxFlex="1 1 100%"
          class="order__details__body__tab_view"
          styleClass="bfx-tabview"
          [activeIndex]="tabIndex"
          (onChange)="onTabChange($event)"
        >
          <p-tabPanel [selected]="!this.tradeDealSelectedIds" [header]="tabHeaders.orderDetails">
            <ng-template pTemplate="header">
              <span [title]="tabTitles.orderDetails">{{tabHeaders.orderDetails}}</span>
            </ng-template>
            <div class="order__details__tab_details_pane__wrapper">
              <div styleClass="order__details__body__fieldset" fxFlex="1 1 50.00%">
                <div fxLayout="row wrap" class="order__details__instrument">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Instrument</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.instrument}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div *ngIf="!isGamma" fxLayout="row wrap" class="order__details__dir">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Dir</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{intentString}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div *ngIf="isGamma" fxLayout="row wrap" class="order__details__dir">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Dealt Ccy</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.dealtCcy}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div *ngIf="!isGamma" fxLayout="row wrap" class="order__details__orderAmt">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Order Amt</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{amountString}}
                  </div>
                  <div
                    class="order__details__body__infobox--usd"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.orderAmtUsd}}"
                    tooltipPosition="left"
                    *ngIf="!orderDetails.orderAmtUsdInvalid"
                  >
                    $
                  </div>
                  <div
                    class="order__details__body__infobox--usd-disabled"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip=""
                    tooltipPosition="left"
                    tooltipDisabled="true"
                    *ngIf="!!orderDetails.orderAmtUsdInvalid"
                  >
                    $
                  </div>
                </div>
                <div
                  *ngIf="!(orderDetails.isMKTOrder || orderDetails.isBenchmarkOrder || isGamma || orderDetails.isAlgoOrder)"
                  fxLayout="row wrap"
                  class="order__details__requestRt"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">
                    {{orderDetails.isAlgoOrder ? 'Limit Price' : 'Request Rate'}}
                  </div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.requestRt}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="markupEnabled"
                  class="order__details__monitoring__markup"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Entry Markup</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.entryMarkup}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__type">
                  <div fxFlex="0 0 116px" class="order__details__body__label">
                    {{orderDetails.isAlgoOrder || orderDetails.isBenchmarkAlgoOrder ? 'Algo Type' :
                    'Type'}}
                  </div>
                  <div
                    fxFlex="1 1 calc(100% - 132px)"
                    class="order__details__body__value"
                    [innerHTML]="orderDetails.type"
                  ></div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  class="order__details__type"
                  *ngIf="orderDetails.isBenchmarkAlgoOrder"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">
                    {{'Algo Profile'}}
                  </div>
                  <div
                    fxFlex="1 1 calc(100% - 132px)"
                    class="order__details__body__value"
                    [innerHTML]="orderDetails.algoProfile"
                  ></div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__product">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Product</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{productString}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" *ngIf="fwdEnabled " class="order__details__value_date">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Value Date</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{valueDateString}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder"
                  fxLayout="row wrap"
                  class="order__details__goodUntil"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Good From</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.goodFrom}}
                  </div>
                  <div
                    class="order__details__body__infobox order__details__body__infobox--good-from-details"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.goodFromDetails}}"
                    tooltipPosition="left"
                    *ngIf="orderDetails.goodFromDetails"
                  >
                    i
                  </div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder"
                  fxLayout="row wrap"
                  class="order__details__goodFrom"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Good Until</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.goodUntil}}
                  </div>
                  <div
                    class="order__details__body__infobox order__details__body__infobox--good-until-details"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.goodUntilDetails}}"
                    tooltipPosition="left"
                    *ngIf="orderDetails.goodUntilDetails"
                  >
                    i
                  </div>
                </div>
                <div
                  *ngIf="orderDetails.isBenchmarkAlgoOrder || orderDetails.isAlgoOrder"
                  fxLayout="row wrap"
                  class="order__details__inflight"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Inflight Checks</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.inflightChecks}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="ndfEnabled && isNdfOrder"
                  class="order__details__fixing_date"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Date</div>
                  <div
                    fxFlex="1 1 calc(100% - 132px)"
                    class="order__details__body__value"
                    [innerHTML]="orderDetails.fixingDate"
                  ></div>
                  <div
                    class="order__details__body__infobox order__details__body__infobox--odd-fixing"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="Custom Fixing Date"
                    tooltipPosition="left"
                    *ngIf="orderDetails.oddFixingDateFg"
                  >
                    <span class="fa fa-fw icon-error pull-left blotter_inline_fa"></span>
                  </div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="ndfEnabled && isNdfOrder"
                  class="order__details__fixing_code"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Code</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingCode}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <!-- Duplicate - here only for Benchmark ALGO -->
                <div
                  *ngIf="orderDetails.isBenchmarkAlgoOrder"
                  fxLayout="row wrap"
                  class="order__details__fixing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Code</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingCode}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
              </div>
              <div class="divider-vertical"></div>
              <div styleClass="order__details__body__fieldset" fxFlex="1 1 50.00%">
                <div
                  *ngIf="orderDetails.isBenchmarkOrder"
                  fxLayout="row wrap"
                  class="order__details__fixing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Code</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingCode}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="orderDetails.isBenchmarkOrder"
                  fxLayout="row wrap"
                  class="order__details__fixing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Time</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingDate}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="orderDetails.isBenchmarkOrder"
                  fxLayout="row wrap"
                  class="order__details__fixing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Time UTC</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingDateUtc}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>

                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__open_amt"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Open Amt</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.openAmt}}
                  </div>
                  <div
                    class="order__details__body__infobox--usd"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.openAmtUsd}}"
                    tooltipPosition="left"
                    *ngIf="!orderDetails.openAmtUsdInvalid"
                  >
                    $
                  </div>
                  <div
                    class="order__details__body__infobox--usd-disabled"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.openAmtUsd}}"
                    tooltipPosition="left"
                    tooltipDisabled="true"
                    *ngIf="!!orderDetails.openAmtUsdInvalid"
                  >
                    $
                  </div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__fill_amt"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fill Amt</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fillAmt}}
                  </div>
                  <div
                    class="order__details__body__infobox--usd"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.fillAmtUsd}}"
                    tooltipPosition="left"
                    *ngIf="!orderDetails.fillAmtUsdInvalid"
                  >
                    $
                  </div>
                  <div
                    class="order__details__body__infobox--usd-disabled"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="{{orderDetails.fillAmtUsd}}"
                    tooltipPosition="right"
                    tooltipDisabled="true"
                    *ngIf="!!orderDetails.fillAmtUsdInvalid"
                  >
                    $
                  </div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__avg_px"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Market Spot</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.avgMktSpot}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__avg_px"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Market Pts</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.avgMarketPoints}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__avg_px"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Market All-In</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.avgMktAllIn}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__avg_px"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Client Spot</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.avgClientSpot}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__avg_px"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Client Pts</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.avgClientPoints}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="!orderDetails.isBenchmarkOrder && !isGamma"
                  fxLayout="row wrap"
                  class="order__details__avg_px"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Client All-In</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.avgPx}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>

                <div
                  *ngIf="!(orderDetails.isMKTOrder || orderDetails.isBenchmarkOrder || orderDetails.isBenchmarkAlgoOrder || orderDetails.isAlgoOrder)"
                  fxLayout="row wrap"
                  class="order__details__suspend"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Suspend</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    <span
                      [appendTo]="desktop ? 'target' : 'body'"
                      bfxTooltip="{{orderDetails.suspend}}"
                      tooltipPosition="top"
                    >
                      {{orderDetails.suspend}}
                    </span>
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__hold_stp">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Hold STP</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.holdStp}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__private">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Private</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.private}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <!-- STP Aggregation -->
                <div
                  *ngIf="orderDetails.stpAggregationEnabled != null"
                  fxLayout="row wrap"
                  class="order__details__stpagg"
                >
                  <div
                    fxFlex="0 0 116px"
                    class="order__details__body__label"
                    [appendTo]="desktop ? 'target' : 'body'"
                    bfxTooltip="STP Aggregation"
                    tooltipPosition="top"
                  >
                    STP Aggregation
                  </div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.stpAggregationEnabled}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <!-- Duplicate - here only for Benchmark ALGO -->
                <div
                  *ngIf="orderDetails.isBenchmarkAlgoOrder"
                  fxLayout="row wrap"
                  class="order__details__fixing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Time</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingDate}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <!-- Duplicate - here only for Benchmark ALGO -->
                <div
                  *ngIf="orderDetails.isBenchmarkAlgoOrder"
                  fxLayout="row wrap"
                  class="order__details__fixing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fixing Time UTC</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.fixingDateUtc}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  *ngIf="orderDetails.autoForwardPricing != null"
                  fxLayout="row wrap"
                  class="order__details__autoFwdPricing"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">
                    Auto Forward Roll
                  </div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.autoForwardPricing}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>

                <div
                  *ngIf="!orderDetails.isLimit && !orderDetails.isAlgoOrder && !orderDetails.isBenchmarkAlgoOrder"
                  fxLayout="row wrap"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Forward First</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.reqQuoteId != null ? orderDetails.reqQuoteId:'-'}}
                  </div>
                  <div fxFlex="0 0 15px" class="order__details__body__infobox--placeholder"></div>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <!-- MONITORING -->
          <p-tabPanel
            *ngIf="!orderDetails.isAlgoOrder && !orderDetails.isBenchmarkAlgoOrder && !orderDetails.isBenchmarkOrder"
            [header]="tabHeaders.monitoring"
          >
            <ng-template pTemplate="header">
              <span [title]="tabTitles.monitoring">{{tabHeaders.monitoring}}</span>
            </ng-template>
            <div class="order__details__tab_details_pane__wrapper">
              <div styleClass="order__details__body__fieldset" fxFlex="1 1 50.00%">
                <div fxLayout="row wrap" class="order__details__monitoring__requestRt">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Request Rate</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{!isGamma? orderDetails.requestRt: "-"}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="markupEnabled"
                  class="order__details__monitoring__markup"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Markup</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.markup}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="markupEnabled && fwdEnabled"
                  class="order__details__fwd_tracking"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fwd Tracking</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{!isGamma? orderDetails.forwardTracking: "-"}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="markupEnabled && fwdEnabled"
                  class="order__details__fwd_points"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Fwd Pts</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{!isGamma? orderDetails.forwardPts: "-"}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__monitoring__spotTracking">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Spot Tracking</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{!isGamma? orderDetails.spotTracking: "-"}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>

                <div
                  fxLayout="row wrap"
                  *ngIf="orderDetails.monitoringTsl"
                  class="order__details__monitoring__tslPips"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">TSL Pips</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.tslPips}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="orderDetails.monitoringTsl"
                  class="order__details__monitoring__tslTracking"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">TSL Tracking</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.tslTracking}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="orderDetails.monitoringTsl"
                  class="order__details__monitoring__tslStartTracking"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">
                    Start Tracking At
                  </div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.tslStartTracking}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  *ngIf="orderDetails.monitoringTsl"
                  class="order__details__monitoring__tslOrigRequestRt"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Orig Request Rt</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.tslOrigRequestRt}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
              </div>
              <div class="divider-vertical"></div>
              <div class="order__details__body__fieldset" fxFlex="1 1 50.00%">
                <div fxLayout="row wrap" class="order__details__monitoring__exec_channel">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Exec Channel</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.execChannel}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__monitoring__auto_eligible">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Auto Eligible</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.autoEligible}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__monitoring__side">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Side</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{!isGamma? orderDetails.side: "-"}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div fxLayout="row wrap" class="order__details__monitoring__rateSource">
                  <div fxFlex="0 0 116px" class="order__details__body__label">Rate Source</div>
                  <div fxFlex="1 1 calc(100% - 132px)" class="order__details__body__value">
                    {{orderDetails.rateSource}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
                <div
                  fxLayout="row wrap"
                  class="order__details__monitoring__trigger"
                  *ngIf="fwdEnabled && ndfEnabled && (orderDetails.product=='NDF' || orderDetails.product=='NDF (Spot)' || orderDetails.product =='Fwd' || orderDetails.product=='Fwd (Spot)')"
                >
                  <div fxFlex="0 0 116px" class="order__details__body__label">Trigger</div>
                  <div
                    fxFlex="1 1 180px"
                    style="max-width: 100%"
                    class="order__details__body__value"
                  >
                    {{orderDetails.trigger ? orderDetails.trigger : orderDetails.product}}
                  </div>
                  <div class="order__details__body__infobox--placeholder"></div>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <!-- PASS-THROUGH PARAMETERS -->
          <p-tabPanel *ngIf="showPassThroughTab" [header]="tabHeaders.passThrough">
            <ng-template pTemplate="header">
              <span [title]="tabTitles.passThrough">{{tabHeaders.passThrough}}</span>
            </ng-template>
            <p-dataTable
              styleClass="order__details__tab__pass-through__parameters__table"
              [value]="orderDetails.passThroughParameters"
              scrollable="true"
              scrollHeight="200px"
            >
              <p-column field="type" header="Parameter Type" styleClass="pass-through-column">
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <div class="ui-overlaypanel-cell">{{data.type}}</div>
                </ng-template>
              </p-column>
              <p-column field="label" header="Parameter Name" styleClass="pass-through-column">
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <div class="ui-overlaypanel-cell">{{data.label}}</div>
                </ng-template>
              </p-column>
              <p-column field="value" header="Parameter Value" styleClass="pass-through-column">
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <div class="ui-overlaypanel-cell">{{data.value}}</div>
                </ng-template>
              </p-column>
            </p-dataTable>
          </p-tabPanel>

          <!-- STRATEGY PARAMETERS -->
          <p-tabPanel
            *ngIf="orderDetails.isAlgoOrder || orderDetails.isBenchmarkAlgoOrder || orderDetails.isLimit"
            [header]="tabHeaders.strategyParams"
          >
            <ng-template pTemplate="header">
              <span [title]="tabTitles.strategyParams">{{tabHeaders.strategyParams}}</span>
            </ng-template>
            <p-dataTable
              styleClass="order__details__tab__strategy__parameters__table"
              [value]="orderDetails.strategyParameters"
              scrollable="true"
              scrollHeight="200px"
            >
              <p-column
                field="parameterName"
                header="Strategy Parameter"
                styleClass="strategy-column"
              >
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <div class="ui-overlaypanel-cell">{{data.parameterName}}</div>
                </ng-template>
              </p-column>
              <p-column
                field="parameterValue"
                header="Parameter Value"
                styleClass="strategy-column"
              >
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <div class="ui-overlaypanel-cell">{{data.parameterValue}}</div>
                </ng-template>
              </p-column>
            </p-dataTable>
          </p-tabPanel>

          <!-- COMMENTS -->
          <p-tabPanel [header]="tabHeaders.comments">
            <ng-template pTemplate="header">
              <span [title]="tabTitles.comments">{{tabHeaders.comments}}</span>
            </ng-template>
            <div class="order__details__comments">
              <div fxLayout="column" class="order__details__tab__comment">
                <div class="order__details__body__label">Client Comments</div>
                <div
                  class="order__details__tab__comment__client__comment"
                  [ngClass]="{'disabled--private-comments' : !enablePrivateComments}"
                  [ngStyle]="{'min-height':isNdfOrder ? NDF_MIN_COMMENT_WINDOW_HEIGHT : MIN_COMMENT_WINDOW_HEIGHT}"
                >
                  {{orderDetails.clientCommentText ?? '-'}}
                </div>
              </div>
              <div
                fxLayout="column"
                class="order__details__tab__comment"
                *ngIf="enablePrivateComments"
              >
                <div class="order__details__body__label">Private Comments</div>
                <div
                  class="order__details__tab__comment__private__comment"
                  [ngStyle]="{'min-height':isNdfOrder ? NDF_MIN_COMMENT_WINDOW_HEIGHT : MIN_COMMENT_WINDOW_HEIGHT}"
                >
                  {{orderDetails.privateCommentText ?? '-'}}
                </div>
              </div>
            </div>
          </p-tabPanel>
          <!-- TRADES -->
          <p-tabPanel
            #tradesTab
            [selected]="!!this.tradeDealSelectedIds"
            *ngIf="control.hasOrderDetails && !isBenchmarkClientOrder"
            [header]="tabHeaders.clientTrades"
          >
            <ng-template pTemplate="header">
              <span [title]="tabTitles.clientTrades"
                >{{tabHeaders.clientTrades}} ({{embeddedTradeCount == null ? '…' :
                embeddedTradeCount}})</span
              >
            </ng-template>
            <div class="order__details__tab__trade_pane">
              <bfx-order-details-trade-blotter
                #embeddedTradeBlotter
                doubleClickOpenTradeDetail="true"
              ></bfx-order-details-trade-blotter>
            </div>
          </p-tabPanel>

          <!-- New Allocations -->
          <p-tabPanel
            #newAllocationsTab
            *ngIf="control.hasOrderDetails && ( isBenchmarkClientOrder )"
            [header]="tabHeaders.allocations"
          >
            <ng-template pTemplate="header">
              <span [title]="tabTitles.allocations"
                >{{tabHeaders.allocations}} ({{embeddedAllocationsCount == null ? '…' :
                embeddedAllocationsCount}})</span
              >
            </ng-template>
            <div class="order__details__tab__trade_pane">
              <bfx-allocations-blotter
                #embeddedAllocationsBlotter
                [order]="orderDetails"
                [ccyPair]="ccyPair"
                (selectedDealId)="onSelectedAllocationDealChange( $event)"
              ></bfx-allocations-blotter>
            </div>
          </p-tabPanel>

          <!-- ALLOCATIONS -->
          <!-- <p-tabPanel
            *ngIf="control.hasOrderDetails && ( isBenchmarkClientOrder )"
            [header]="tabHeaders.allocations"
          >
            <ng-template pTemplate="header">
              <span [title]="tabTitles.allocations"
                >{{tabHeaders.allocations}} ({{embeddedAllocationsCount == null ? '…' :
                embeddedAllocationsCount}})</span
              >
            </ng-template>
            <div class="order__details__tab__trade_pane">
              <ag-grid-angular
                #embeddedAllocationsBlotter
                class="ag-bcdfx"
                [columnDefs]="columnDefs"
                [gridOptions]="gridOptions"
                [showToolPanel]="false"
                (filterChanged)="onFilterChanged()"
                (mouseup)="onMouseUp($event)"
                (contextmenu)="handleClick($event)"
               >
              </ag-grid-angular>
              <bfx-blotter-column-selector
                [currentLadderBlotter]="blotterInstance"
                bfxElementOnBody
              ></bfx-blotter-column-selector>
            </div>
          </p-tabPanel> -->
          <bfx-trade-context-menu
            [orderDetails]="true"
            [currentLadderBlotter]="blotterInstance"
            bfxElementOnBody
          ></bfx-trade-context-menu>
          <p-tabPanel
            #tradesTab
            [selected]="!!this.tradeDealSelectedIds"
            *ngIf="control.hasOrderDetails"
            [header]="tabHeaders.riskTrades"
          >
            <ng-template pTemplate="header">
              <span [title]="tabTitles.riskTrades"
                >{{tabHeaders.riskTrades}} ({{embeddedRiskTradeCount == null ? '…' :
                embeddedRiskTradeCount}})</span
              >
            </ng-template>
            <div class="order__details__tab__trade_pane">
              <bfx-order-details-risk-trade-blotter
                #embeddedRiskTradeBlotter
                doubleClickOpenTradeDetail="true"
              ></bfx-order-details-risk-trade-blotter>
            </div>
          </p-tabPanel>
        </p-tabView>
        <div class="divider"></div>
        <div class="popup-footer order__details__footer">
          <button
            pButton
            class="bfx-button-secondary-moderate order__details__footer__button-actions bfx-button-sm"
            [disabled]="isContextMenuEmpty"
            (click)="actions_show($event)"
          >
            Actions
          </button>

          <div class="order__details__footer__button__space">
            <div
              class="order___footer__button__bar__allocations__toggle"
              *ngIf="allocationToggleVisible && currencyPairIds?.size > 1"
            >
              <bfx-order-details-ccy-selector
                [model]="currencyPairIds"
                [activeItem]="ccyPair"
                (onPairChange)="onPairChanged($event)"
              >
              </bfx-order-details-ccy-selector>
            </div>
          </div>

          <button
            pButton
            class="bfx-button-secondary-bold order__details__footer__button-trade-details bfx-button-sm"
            (click)="actions_view_deal_details($event)"
            [disabled]="!viewTradesEnabled"
          >
            Trade Details
          </button>

          <button
            pButton
            class="bfx-button-secondary-bold order__details__footer__button-audit-log bfx-button-sm"
            (click)="actions_show_audit_log($event)"
          >
            Audit Log
          </button>

          <button
            pButton
            class="bfx-button-secondary-moderate order__details__footer__button-close bfx-button-sm"
            (click)="close($event)"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="divider-vertical" *ngIf="control.hasStrategy || isGamma"></div>

  <!-- STRATEGY VIEWER Sidepane -->
  <div
    class="popup-callout"
    *ngIf="control.hasStrategy"
    class="order__details__strategy__viewer bfx-test-strategy"
    fxLayout="row wrap"
    fxFlex="1 1 420px"
    fxFlexOrder="2"
  >
    <perfect-scrollbar
      #strategyLayoutPS
      [config]="control.scrollbarConfig"
      [usePSClass]
      class="strategy__viewer__diagram"
      fxFlex
    >
      <div
        class="strategy__viewer__layout__target"
        #strategyLayoutTarget
        (selection)="select($event)"
        (remove)="remove($event)"
      ></div>
    </perfect-scrollbar>
  </div>

  <!-- GAMMA Sidepane -->
  <div
    *ngIf="isGamma"
    class="order__details__strategy__viewer bfx-test-strategy"
    fxLayout="row wrap"
    fxFlex="1 1 532px"
    fxFlexOrder="2"
  >
    <bfx-gamma-rungs-panel [rungs]="gammaRungs" fxFlex="1 1 100.00%"> </bfx-gamma-rungs-panel>
  </div>
  <bfx-order-details-context-menu
    [currentLadderBlotter]="currentLadderBlotter"
    bfxElementOnBody
  ></bfx-order-details-context-menu>
</div>
